import React from 'react';
import { Link } from 'react-router-dom';
import { Offer } from '../types';
import { Heart } from 'lucide-react';
interface OfferCardProps {
  offer: Offer;
}
export function OfferCard({
  offer
}: OfferCardProps) {
  return <Link to={`/offers/${offer.id}`} className="group block bg-white rounded-xl overflow-hidden border border-gray-200 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 h-full" data-id="element-131">
      {/* Image Container */}
      <div className="relative aspect-[4/3] overflow-hidden bg-gray-100" data-id="element-132">
        {offer.imageUrl ? <img src={offer.imageUrl} alt={offer.merchant} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-133" /> : <div className="w-full h-full flex items-center justify-center text-gray-400 font-medium bg-gray-200" data-id="element-134">
            Product Image
          </div>}

        {/* Heart Icon Overlay */}
        <button className="absolute top-4 right-4 p-2 rounded-full bg-white/90 hover:bg-white text-gray-600 hover:text-red-500 transition-colors shadow-sm z-10" onClick={e => {
        e.preventDefault();
        // Favorite logic would go here
      }} aria-label="Add to favorites" data-id="element-135">
          <Heart className="w-5 h-5" data-id="element-136" />
        </button>

        {/* Cashback Badge Overlay (Optional - can be here or below) */}
        <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-full shadow-sm border border-gray-100" data-id="element-137">
          <span className="font-bold text-amber-700" data-id="element-138">
            {offer.cashbackPercent}% Cash Back
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="p-6" data-id="element-139">
        <div className="flex justify-between items-start mb-2" data-id="element-140">
          <h3 className="text-2xl font-bold text-gray-900 group-hover:text-gray-700 transition-colors" data-id="element-141">
            {offer.merchant}
          </h3>
        </div>

        <p className="text-gray-600 text-lg leading-relaxed line-clamp-2" data-id="element-142">
          {offer.description}
        </p>

        <div className="mt-4 flex items-center text-sm text-gray-500 font-medium" data-id="element-143">
          <span className="uppercase tracking-wider text-xs" data-id="element-144">
            {offer.category}
          </span>
          <span className="mx-2" data-id="element-145">•</span>
          <span data-id="element-146">Expires {new Date(offer.expiresAt).toLocaleDateString()}</span>
        </div>
      </div>
    </Link>;
}